import React from 'react';

const Card = ({
    Titre, SousTitre, Info, onClick, className, children, BadgeNew, classCard, styleCss 
}) => (
    <div className={`card mb-3 ${className !== undefined ? className : ''}`} onClick={onClick} style={styleCss ? styleCss : {}}>
        <div className={`card-body ${classCard !== undefined ? classCard : ''}`}>
            <div className="d-flex justify-content-between">
                {Titre !== undefined && <h4 className="card-title">{Titre} {BadgeNew ? <span className="badge badge-info">Nouveau</span> : null}</h4>}
                {Info !== undefined && <i className="fas fa-info-circle fa-2x text-info" onMouseOver={() => { cacheAfficheInfo(false); }} onMouseOut={() => { cacheAfficheInfo(true); }} style={{ cursor: 'pointer' }} />}
            </div>
            {Info !== undefined && <div id="tooltipInfo" style={{ zIndex: 1 }} className="position-absolute alert alert-info mr-3" hidden>{Info}</div>}
            {SousTitre !== undefined && <h5 className="card-subtitle mb-2 text-muted">{SousTitre}</h5>}
            {children}
        </div>
    </div>
);

const cacheAfficheInfo = (bool) => {
    document.getElementById('tooltipInfo').hidden = bool;
};

export const LigneCard = ({
    titre, classeTitre, valeur, classeValeur, derniereLigne, iconePre, iconePost, iconeLib, longTitre,
}) => (
    <div className={`row ${derniereLigne ? 'mb-0' : 'mb-2'}`} style={{alignItems:"center"}}>
        <span className={`${longTitre ? 'col-8' : 'col-4'} text-secondary ${classeTitre !== undefined ? classeTitre : ''}`}>{titre}</span>
        <span className={`${longTitre ? 'col-4' : 'col-8'} ${classeValeur !== undefined ? classeValeur : ''}`}>
            {iconePre !== undefined && <i className={`mr-1 ${iconePre}`} title={iconeLib ? iconeLib : ""} />}
            {valeur}
            {iconePost !== undefined && <i className={`ml-1 ${iconePost}`} title={iconeLib ? iconeLib : ""}/>}
        </span>
    </div>
);

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js